import React, { useState } from "react";
import { Container, Modal } from "react-bootstrap";
import { POSTERS, Poster } from "../data/shop";
import "./Posters.css";

export const Posters = () => {
  const [open, setOpen] = useState<Poster | null>(null);

  return (
    <section id="wall" className="posters">
      <Container>
        <div className="section-head">
          <span className="eyebrow">Shop Art</span>
          <h2 className="section-title gold-text">On the Wall</h2>
          <p className="lede mx-auto mt-3">
            The signs, posters and artwork that hang around the shop. Tap any
            one to see it up close.
          </p>
          <div className="rule">
            <span className="diamond" />
          </div>
        </div>

        <div className="posters__wall">
          {POSTERS.map((poster) => (
            <button
              type="button"
              className={`poster${poster.feature ? " is-feature" : ""}`}
              key={poster.src}
              onClick={() => setOpen(poster)}
            >
              <span className="poster__frame frame">
                <img
                  src={poster.src}
                  alt={poster.alt}
                  width={poster.width}
                  height={poster.height}
                  loading="lazy"
                />
              </span>
              <span className="poster__plate">
                <span className="poster__title">{poster.title}</span>
                <span className="poster__caption">{poster.caption}</span>
              </span>
            </button>
          ))}
        </div>
      </Container>

      <Modal
        show={open !== null}
        onHide={() => setOpen(null)}
        size="lg"
        centered
        className="poster-modal"
        backdropClassName="poster-modal-backdrop"
      >
        {open && (
          <Modal.Body className="text-center">
            <button
              type="button"
              className="poster-modal__close"
              aria-label="Close"
              onClick={() => setOpen(null)}
            >
              &times;
            </button>
            <img src={open.src} alt={open.alt} />
            <span className="poster__title mt-3 d-block">{open.title}</span>
            <span className="poster__caption">{open.caption}</span>
          </Modal.Body>
        )}
      </Modal>
    </section>
  );
};
